export default {"src":"/_next/static/media/ico-setting-ring.091d8da1.svg","height":29,"width":27};